import { type FC, type ReactNode, memo } from "react";

import { Card } from "@snapchat/snap-design-system";

import { SearchBar } from "./searchbar";

interface SearchableCardOwnProps {
    onSearch: (text: string) => unknown;
    searchPlaceholder?: string;
    searchTestId?: string;
    searchValue: string;
    padBody?: boolean;
    className?: string;
    isLoading?: boolean;
    tooltip?: string;
    children: ReactNode;
}

export type SearchableCardProps = SearchableCardOwnProps;

// SDS version https://jira.sc-corp.net/browse/CAMKIT-1629
// Won't use unless SDS Searchbar allows for customizing the disabled field
const SearchableCard: FC<SearchableCardProps> = memo((props) => {
    const { onSearch, searchValue, searchPlaceholder, searchTestId, isLoading, tooltip, ...restProps } = props;

    const valueProp = "searchValue" in props ? { value: searchValue } : {};

    const searchBar = (
        <SearchBar
            onChange={onSearch}
            placeholder={searchPlaceholder}
            data-testid={searchTestId}
            isLoading={isLoading}
            tooltip={tooltip}
            value={searchValue}
            {...valueProp}
        />
    );

    return <Card {...restProps} leftHeaderContent={searchBar} />;
});

SearchableCard.displayName = "SearchableCard";

export { SearchableCard };
